import {
	Button,
	List,
	ListItem,
	ListItemText,
	TextField,
	Typography,
} from "@material-ui/core";
import axios from "axios";
import React, { useEffect, useState } from "react";
import config from "react-global-configuration";
import { toast } from "react-toastify";
import Backdrop from "../../Backdrop/Backdrop";
import Modal from "../../Modal/Modal";

const BuscaClienteModal = (props) => {
	const [modalOpen, SetModalOpen] = useState(false);
	const [palavraBusca, setPalavraBusca] = useState("");
	const [resultadoBusca, setResultadoBusca] = useState();
	const [carregando, setCarregando] = useState(false);
	const [buscandoDadosCliente, setBuscandoDadosCliente] = useState(false);

	useEffect(() => {
		if (palavraBusca && palavraBusca.length >= 3) {
			setCarregando(true);
			axios
				.get(
					config.get("url_api") +
						"totvs/cliente/buscarV2/" +
						palavraBusca +
						"?token=" +
						config.get("token")
				)
				.then((response) => {
					setCarregando(false);
					if (response.data.sucesso) {
						setResultadoBusca(response.data);
					} else {
						setResultadoBusca([]);
					}
				})
				.catch((error) => {
					setCarregando(false);
				});
		} else {
			setResultadoBusca(null);
		}
	}, [palavraBusca]);

	const selecionaCliente = (client) => {
		setCarregando(true);
		setBuscandoDadosCliente(true);
		axios
			.get(
				config.get("url_api") +
					"totvs/cliente/detalhes-liveV2/" +
					documentoUnico(client) +
					"?token=" +
					config.get("token")
			)
			.then((response) => {
				if (response.data.cliente) {
					props.setFormData(response.data.cliente);
					setPalavraBusca({});
					SetModalOpen(false);
					setCarregando(false);
					setBuscandoDadosCliente(false);
				} else {
					toast.error("Erro ao recuperar dados do cliente.");
					setCarregando(false);
				}
			})
			.catch((error) => {
				toast.error("Erro ao recuperar dados do cliente.");
				setCarregando(false);
			});
	};

	const textoDocumentos = (clienteDados) => {
		let saida = "";
		if (clienteDados.cpf) saida += "CPF: " + clienteDados.cpf;

		if (clienteDados.cnpj) {
			if (saida !== "") saida += " | ";
			saida += "CNPJ: " + clienteDados.cnpj;
		}

		if (clienteDados.rg) {
			if (saida !== "") saida += " | ";
			saida += "RG: " + clienteDados.rg;
		}

		return saida;
	};

	const documentoUnico = (clienteDados) => {
		if (clienteDados.cnpj && clienteDados.cnpj !== "00000000000")
			return clienteDados.cnpj;
		if (clienteDados.cpf && clienteDados.cpf !== "00000000000")
			return clienteDados.cpf;
		if (clienteDados.rg) return clienteDados.rg;
	};

	const alterandoBusca = (palavra) => {
		setPalavraBusca(palavra);
	};

	const abrirMidal = () => {
		setPalavraBusca("");
		SetModalOpen(true);
	};

	return (
		<React.Fragment>
			{modalOpen && (
				<Backdrop>
					<Modal
						size="lg"
						title="Buscar cliente"
						onCancel={() => {
							setPalavraBusca(null);
							setResultadoBusca(null);
							SetModalOpen(false);
						}}
						onCancelTopo
						onConfirmLabel="Selecionar cliente"
						saving={carregando}
					>
						{buscandoDadosCliente && (
							<Typography variant="h6" className="text-center">
								Buscando dados do cliente no Totvs
							</Typography>
						)}
						{!buscandoDadosCliente && (
							<>
								<TextField
									margin="dense"
									id="buscar"
									name="buscar"
									label="Buscar por"
									autoComplete="off"
									helperText="Informe o nome ou documento do cliente"
									fullWidth
									autoFocus
									value={palavraBusca}
									onChange={(e) => alterandoBusca(e.target.value)}
								/>
								{/* {loading ? <AutorenewIcon className="spin" /> : ""} */}
								{!carregando && resultadoBusca && resultadoBusca.sucesso && (
									<List component="nav" aria-label="secondary mailbox folders">
										<div className="addProductGroups__container">
											{resultadoBusca.dados.map((cliente) => {
												return (
													<ListItem
														button
														key={cliente.id}
														onClick={() => selecionaCliente(cliente)}
													>
														<ListItemText
															primary={cliente.nome}
															secondary={
																cliente.municipio +
																"/" +
																cliente.estado +
																" | " +
																textoDocumentos(cliente)
															}
														/>
													</ListItem>
												);
											})}
										</div>
									</List>
								)}
								{!carregando &&
									resultadoBusca &&
									resultadoBusca.length === 0 && (
										<div>
											Nenhum cliente encontrado com a palavra informada.
										</div>
									)}
							</>
						)}
					</Modal>
				</Backdrop>
			)}
			<Button
				onClick={() => abrirMidal()}
				variant="contained"
				color="primary"
				size="small"
				className="mb-1"
			>
				Buscar cliente
			</Button>
		</React.Fragment>
	);
};

export default BuscaClienteModal;
